import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyActions, NOTIFICATION_TYPE } from "@lemonadetraining/web-shared";
import { toast } from "sonner";

const Notification = () => {
  const dispatch = useDispatch();
  const notify = useSelector((state) => state.notify);

  useEffect(() => {
    if (!notify.activate) return;

    const description = notify.message || undefined;

    switch (notify.severity) {
      case NOTIFICATION_TYPE.success:
        toast.success(notify.title, { description });
        break;
      case NOTIFICATION_TYPE.error:
        toast.error(notify.title, { description });
        break;
      case NOTIFICATION_TYPE.warning:
        toast.warning(notify.title, { description });
        break;
      case NOTIFICATION_TYPE.info:
      default:
        toast.info(notify.title, { description });
        break;
    }

    dispatch(notifyActions.deactivate());
  }, [notify.activate, notify.severity, notify.title, notify.message, dispatch]);

  return null;
};

export default Notification;
